
Vue.component("el-empty", {
  mounted() {
  },
  props: {
    description: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: '1em'
    },
  },
  template: `
  <div class="el-empty">
    <div class="el-empty__image">
      <iconfont type="iconzanwushuju"></iconfont>
    </div>
    <div class="el-empty__desc">{{description || '暂无数据'}}</div>
  </div>
  `,
});